import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzHeading } from '../../../components';

const Companies = ({ companies }) => {

    return (
        <Container fluid className='p-0 ps-4'>
            <Row className='mt-2 g-0'>
                <Col>
                    <BzHeading className='font-medium font-size3 color-text pt-4 pb-3'>Companies</BzHeading>
                </Col>
            </Row>
            <Row className='g-0 p-0'>
                {companies?.map((item, index) => {
                    return (
                        <div key={index}>
                            <Row className='g-0 bdr-btm pb-2 mb-2'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-medium font-size1 color-subtext'>Name</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-medium font-size1 color-subtext'>Percentage</div>
                                </Col>
                            </Row>
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-text'>HDFC Bank</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-regular font-size3 color-text'>{item.hdfcBank}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-text'>Axis Bank</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-regular font-size3 color-text'>{item.axisBank}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-text'>Larsen &amp; Tourbro</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-regular font-size3 color-text'>{item.laursen_and_turbro}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-text'>Infosys</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-regular font-size3 color-text'>{item.infosys}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-text'>Bajaj Finance</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-regular font-size3 color-text'>{item.bajajFinance}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-text'>TCS</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-start'>
                                    <div className='font-regular font-size3 color-text'>{item.tcs}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 mt-1'>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='cursor-pointer'>
                                        <BzHeading className='font-medium font-size2 color-textual-link-withicon'>Show More</BzHeading>
                                        <div className='icon-20 icon-sort-down background-textual-link-withicon ms-2'></div>
                                        {/* <div className='icon-20 icon-sort-up background-textual-link-withicon ms-2'></div> */}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </Row>
        </Container>

    );
};
export default memo(Companies);